
import { formatDate, parseISODate } from '@/utils/date'
import { getDefaultAvatar } from '@/utils/ui'
import { defineComponent, PropType } from 'vue'
import { TeamMemberRoleChoices } from '~/types/types'

export default defineComponent({
  name: 'InvitedMemberListItem',
  props: {
    role: {
      type: String as PropType<TeamMemberRoleChoices>,
      required: true
    },
    email: {
      type: String,
      required: true
    },
    createdAt: {
      type: String,
      default: undefined
    },
    hideBorder: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      roles: {
        [TeamMemberRoleChoices.Admin]: {
          title: 'Administrator',
          description:
            'Full access to all repositories and the team, including billing, adding, or removing members.'
        },
        [TeamMemberRoleChoices.Contributor]: {
          title: 'Contributor',
          description:
            "Contributors don't have any team level access or any access to change repo level settings."
        },
        [TeamMemberRoleChoices.Member]: {
          title: 'Member',
          description: 'Add and edit specific repositories'
        }
      }
    }
  },
  computed: {
    joining(): string {
      return formatDate(parseISODate(this.createdAt))
    }
  },
  methods: {
    getDefaultAvatar,
    updateRole(newRole: string): void {
      this.$emit('updateRole', {
        email: this.email,
        role: this.role,
        newRole
      })
    },
    cancelInvite(): void {
      this.$emit('cancelInvite', this.email)
    }
  }
})
